import React, { useReducer } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import HeaderFooterShell from '@hydra/common/shell/HeaderFooterShell';
import { GenerationProvider } from '@hydra/common/components/GenerationContext';
import { generationReducer, initialGenerationState } from '@hydra/common/components/generationReducer';

import { useI18n } from '@hydra/common/customHooks';

interface ILocation {
  action: string
  delta: number
  hash: string
  index: number
  key?: string | undefined
  pathname: string
  query: any
  search: string
  state: any
}

interface ICreateContainer {
  children: React.ReactNode,
  match: {
    location: ILocation
  }
}

export default function CreateContainer ({ children, match: { location } }: ICreateContainer) {
  const { translate } = useI18n();
  const { url } = location.query;
  const useGenerationState = useReducer(generationReducer, {
    ...initialGenerationState,
    url: url || ''
  });
  return (
    <GenerationProvider value={useGenerationState}>
      <Helmet>
        <title>{translate('reports_projects_headtitle')}</title>
      </Helmet>
      <HeaderFooterShell>
        {children}
      </HeaderFooterShell>
    </GenerationProvider>
  );
}

CreateContainer.propTypes = {
  children: PropTypes.element
};
